import React, { FunctionComponent } from 'react';

export interface FeeAndTaxProps {
    feesAndTaxes?: Array<string>;
}

const _getFeeAndTaxContent = (feesAndTaxes?: Array<string>) =>
    feesAndTaxes
        ? feesAndTaxes.map((item) => (
              <span
                  key={item}
                  className="eds-text-bs eds-ticket-card-content__fee-information eds-l-pad-right-1"
                  data-spec="variant-fee-and-tax__item"
              >
                  {item}
              </span>
          ))
        : null;

const FeeAndTaxContent: FunctionComponent<FeeAndTaxProps> = ({
    feesAndTaxes,
}) => {
    const content = _getFeeAndTaxContent(feesAndTaxes);
    return <span data-spec="variant-fee-and-tax">{content}</span>;
};

export default FeeAndTaxContent;
